

export const state = {
    //机构管理
    mechOranization: "",
    mechNavList: [],//机构面包屑
    mechTreeList: [],
    batchNo: "",//新增业务员缓存标号
    currentTreeId: "",//当前选中的tree  id
    companyList: [],//公司列表
    themeList: [],//产品分类
    companyListEntity: [],//公司列表 线下
    themeListEntity: [],//产品分类 线下
    allAgreeCompany:[],
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),//用户信息  userType字段   1运营     2转介人 
    baseInfo:JSON.parse(sessionStorage.getItem('baseInfo') || '{}'),//对账单基本信息
    insureItems:JSON.parse(sessionStorage.getItem('insureItems') || '[]'),//对账单保司保单
    insureItemsPersonal:JSON.parse(sessionStorage.getItem('insureItemsPersonal') || '[]'),//对账单保司保单仅用于传递值
    compareVOS:JSON.parse(sessionStorage.getItem('compareVOS') || '[]'),// (编辑)保司保单对比结果
    policies:JSON.parse(sessionStorage.getItem('policies') || '[]'),// 系统保单
    compareDTOS:JSON.parse(sessionStorage.getItem('compareDTOS') || '[]'),//(新增)对账单对比结果
    requestId:'', //请求id
    regionsArr:[],//区域数据
}
